/**
 * Reusable button component.
 * @param {{
 *   children: React.ReactNode,
 *   variant?: 'primary' | 'secondary' | 'ghost' | 'danger',
 *   size?: 'sm' | 'md' | 'lg',
 *   className?: string,
 *   ...props
 * }} props
 */
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  ...props
}) {
  const base =
    'inline-flex items-center justify-center font-medium rounded-md transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 disabled:opacity-50 disabled:pointer-events-none';

  const variants = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700',
    secondary:
      'bg-surface-raised border border-border text-text-primary hover:bg-surface-sunken',
    ghost: 'text-text-secondary hover:bg-surface-sunken hover:text-text-primary',
    danger: 'bg-error text-white hover:opacity-90',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm gap-1.5',
    md: 'px-4 py-2 text-sm gap-2',
    lg: 'px-6 py-3 text-base gap-2',
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}